export default __webpack_public_path__ + "static/media/main_bg_top_right.6f0c7ed1.svg";